module.exports = __webpack_public_path__ + "static/media/radiation-alt.f8ff2224.svg";